<template>
  <div v-if="galleryContent" class="photo-box cursor-pointer">
    <div v-if="!isVideo" @click="showImage" class="content" :style="{'background-image': 'url(' + fileUrl + ')'}">
    </div>
    <video v-else width="100%" height="100%" controls>
      <source :src="isVideo" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import { API_HELPER } from "@/helpers/api.js";

export default {
  props: {
    galleryContent: String,
  },
  computed: {
    fileUrl() {
      return this.isVideo ? this.isVideo : API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.galleryContent]);
    },
    isVideo() {
      let typeOfVideos = ['mp4', 'avi'];
      let path = this.galleryContent;
      return typeOfVideos.some(ext => path.includes(ext)) ? API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, path]) : null;
    }
  },
  methods: {
    showImage() {
      this.$emit("showImage");
    }
  },
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  display: block;
}
.photo-box {
  width: 100%;
  max-width: 100%;
  height: clamp(160px, 28vw, 245px);
  margin: 0;
  padding: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.photo-box:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
video {
  object-fit: cover;
}

@media (max-width: 767px) {
  .photo-box {
    max-width: 100% !important;
    max-height: none !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    line-height: 0 !important;
  }

  .content {
    width: 100% !important;
    height: auto !important;
    min-height: 200px;
    aspect-ratio: 16/9;
    display: block;
  }
}

@media (max-width: 575px) {
  .photo-box {
    max-width: 100% !important;
    max-height: none !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    line-height: 0 !important;
  }

  .content {
    width: 100% !important;
    height: auto !important;
    min-height: 250px;
    aspect-ratio: 16/9;
    display: block;
  }
}
</style>
